import axiosInstance from "./api_helper";

const promotionService = {
    list: async () => {
        return axiosInstance.get("/api/promotions");
    },

    getById: async (id) => {
        return axiosInstance.get(`/api/promotions/${id}`);
    },

    create: async (payload) => {
        return axiosInstance.post("/api/promotions", payload);
    },

    print: async (id) => {
        return axiosInstance.get(`/api/promotions/${id}/print`, {
            responseType: "blob",
        });
    },
};

export default promotionService;